import type {
  QueryFunctionContext,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { junip } from 'lib/junip';
import type { JunipProduct } from 'types/reviews';
import type { JunipProductRaw } from 'types/reviews/rawData';
import { convertKeysToCamelCase } from 'utils/convertKeysToCamelCase';

interface JunipProductAPIResponse {
  product: JunipProductRaw;
}

export const REVIEWED_PRODUCT_KEY = 'reviewedProduct';

export type UseReviewedProductQueryKey = [string, string?];

export type UseReviewedProductSelector = JunipProduct | undefined;

export interface UseReviewedProductOptions {
  productId?: string;
}

export const fetchReviewedProduct = async ({
  queryKey,
}: QueryFunctionContext<UseReviewedProductQueryKey>): Promise<JunipProduct | null> => {
  const [, productId] = queryKey;

  if (!productId) return null;

  const res = await junip<JunipProductAPIResponse>(`/v1/products/${productId}`);

  return convertKeysToCamelCase(res.product);
};

export const useReviewedProduct = ({
  productId,
}: UseReviewedProductOptions): UseQueryResult<
  UseReviewedProductSelector,
  unknown
> => {
  const queryKey: UseReviewedProductQueryKey = [
    REVIEWED_PRODUCT_KEY,
    productId,
  ];

  return useQuery<
    JunipProduct | null,
    unknown,
    UseReviewedProductSelector,
    UseReviewedProductQueryKey
  >({
    queryKey,
    queryFn: fetchReviewedProduct,
  });
};
